import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CenteredLoader } from 'ui';

export const Redirect = ({ to }: { to: string }) => {
  const params = useParams();

  useEffect(() => {
    // Replace placeholders in the URL (e.g., ':id') with the actual params
    let destination = to;
    Object.keys(params).forEach((key) => {
      if (params[key] == null) return;
      destination = destination.replace(new RegExp(`:${key}`, 'g'), encodeURIComponent(params[key]));
    });
    window.location.replace(destination);
  }, [params, to]);

  return <CenteredLoader />;
};
